// CSS del Web Component (Shadow DOM) con la identidad KYP: tinta, papel, lacre (solo sello,
// progreso y botón principal) y gris. Contraste AA y `prefers-reduced-motion`.
export const KYP_TOKENS = {
  ink: '#0B0D10',
  paper: '#FAFAF7',
  lacre: '#E0141E',
  gray: '#8A8F98',
} as const;

export const STYLES = `
:host{all:initial;display:block;contain:content;
--kyp-ink:${KYP_TOKENS.ink};--kyp-paper:${KYP_TOKENS.paper};--kyp-lacre:${KYP_TOKENS.lacre};--kyp-gray:${KYP_TOKENS.gray};
--kyp-gray-text:#5C626B;
font-family:Inter,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;color:var(--kyp-ink);font-size:16px;line-height:1.45}
*,*::before,*::after{box-sizing:border-box}
.kyp{background:var(--kyp-paper);color:var(--kyp-ink);min-height:100%;display:flex;flex-direction:column;gap:12px;padding:16px;max-width:640px;margin:0 auto}
header{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
.brand{font-weight:800;letter-spacing:.08em}
.seal{display:inline-block;width:14px;height:14px;border-radius:50%;background:var(--kyp-lacre)}
.steplabel{color:var(--kyp-gray-text);font-size:14px;flex:1}
.bar{width:100%;height:4px;background:#E6E6E1;border-radius:2px;overflow:hidden}
.fill{height:100%;width:0;background:var(--kyp-lacre);transition:width .3s ease}
.stage{position:relative;background:var(--kyp-ink);border-radius:12px;overflow:hidden;aspect-ratio:4/3}
.stage[hidden]{display:none}
video{width:100%;height:100%;object-fit:cover;display:block}
.frame{position:absolute;inset:10%;border:2px solid var(--kyp-paper);border-radius:8px;pointer-events:none;opacity:.85}
h2{font-size:20px;margin:0;outline:none}
p{margin:0}
.body{color:var(--kyp-ink)}
.msg{min-height:1.4em;color:var(--kyp-ink);font-weight:600}
.msg.warn::before{content:"! ";color:var(--kyp-lacre)}
form{display:grid;gap:10px}
label{display:grid;gap:4px;font-size:14px;color:var(--kyp-gray-text)}
input,select,textarea{font:inherit;color:var(--kyp-ink);background:#fff;border:1px solid var(--kyp-gray);border-radius:8px;padding:10px 12px;min-height:44px}
input:focus-visible,select:focus-visible,button:focus-visible,a:focus-visible{outline:3px solid var(--kyp-ink);outline-offset:2px}
.row{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}
.actions{display:flex;gap:10px;flex-wrap:wrap}
button{font:inherit;font-weight:700;border-radius:999px;padding:12px 20px;min-height:48px;cursor:pointer;border:2px solid var(--kyp-ink);background:transparent;color:var(--kyp-ink)}
button.primary{background:var(--kyp-lacre);border-color:var(--kyp-lacre);color:#fff}
button[disabled]{opacity:.55;cursor:progress}
a{color:var(--kyp-ink);font-weight:600}
.stages{list-style:none;padding:0;margin:0;display:flex;gap:16px;flex-wrap:wrap}
.stages li{color:var(--kyp-gray-text)}
.stages li.on{color:var(--kyp-ink);font-weight:700}
.stages li.on::before{content:"";display:inline-block;width:10px;height:10px;border-radius:50%;background:var(--kyp-lacre);margin-right:6px}
.qr{width:220px;max-width:100%;background:#fff;padding:8px;border-radius:8px}
.qr svg{width:100%;height:auto;display:block}
.code{font-size:28px;font-weight:800;letter-spacing:.2em}
.overlay{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:flex-end;justify-content:center;padding:32px 16px;background:#000;color:#fff}
.overlay[hidden]{display:none}
.overlay .hint{background:rgba(11,13,16,.8);color:#fff;padding:12px 16px;border-radius:12px;font-weight:700;text-align:center}
.overlay .orbit{display:block;height:4px;background:rgba(255,255,255,.3);border-radius:2px;margin-top:8px;overflow:hidden}
.overlay .orbit span{display:block;height:100%;width:0;background:#fff}
.sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}
@media (prefers-reduced-motion:reduce){*{transition:none!important;animation:none!important}}
`;
